import { render, staticRenderFns } from "./ReportOrderSumsPerSupplierPage.vue?vue&type=template&id=b65ffdce&scoped=true"
import script from "./ReportOrderSumsPerSupplierPage.vue?vue&type=script&lang=js"
export * from "./ReportOrderSumsPerSupplierPage.vue?vue&type=script&lang=js"
import style0 from "./ReportOrderSumsPerSupplierPage.vue?vue&type=style&index=0&id=b65ffdce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b65ffdce",
  null
  
)

export default component.exports